<template>
    <div>
        <audios v-if="telefono"  :uniqueid="uniqueid"/>
        <reporte_whatsapp v-if="whatsapp" :uniqueid="uniqueid" />
    </div>
</template>
<script>
    import  audios  from "../audios/index.vue";
    import  reporte_whatsapp  from "../reporte_whatsapp/index.vue";
export default {
    props: ['uniqueid','canal'],
    components:{audios,reporte_whatsapp},
    data() {
        return {
            telefono: false,
            whatsapp: false
        }
    },
    mounted() {
        if (this.uniqueid && (this.canal=='telefono' || this.canal=='telefono_wsp')) {
            this.telefono = true;
        }else if(this.canal=="whatsapp"){
            this.whatsapp = true
        }
    },
}
</script>
